import { useCallback, useRef, useState } from "react";
import { Linking } from "react-native";
import { createSarvCallAPI } from "@services/api";

export default function useSarvCall() {
  const sarvModeRef = useRef("DISABLED");
  const sarvCliNumberRef = useRef("");
  const [showSarvModal, setShowSarvModal] = useState(false);

  const updateSarvData = useCallback((data) => {
    if (data?.sarv_mode) sarvModeRef.current = data.sarv_mode;
    const cli = data?.sarv_cli_number ?? data?.sarvCliNumber;
    if (cli) sarvCliNumberRef.current = cli;
  }, []);

  // callmatic_mode: optional per-touchpoint override stamped on each CX card
  // by the backend (touchpoint-level Callmatic). Falls back to the
  // response-level mode for cards/screens that don't carry it.
  const createCall = useCallback((phone, cx_id, route_id, callmatic_mode) => {
    if (!phone) return;
    const mode = callmatic_mode || sarvModeRef.current;
    const cliNumber = sarvCliNumberRef.current;
    createSarvCallAPI({
      cx_phone_number: phone,
      sarv_cli_number: cliNumber,
      sarv_mode: mode,
      cx_id,
      route_id,
    }).catch((error) => console.error("createSarvCall error:", error));
    if (mode === "DISABLED") {
      Linking.openURL(`tel:${phone}`);
    } else if (mode === "UNIDIRECTIONAL") {
      Linking.openURL(`tel:${cliNumber}`);
    } else if (mode === "TWO_WAY_CALL") {
      setShowSarvModal(true);
    }
  }, []);

  return { createCall, showSarvModal, setShowSarvModal, updateSarvData };
}
